/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_Landing_TitleInputs */

const en_service_health_nav_landing_title = /** @type {(inputs: Service_Health_Nav_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Health Navigator`)
};

const fr_service_health_nav_landing_title = /** @type {(inputs: Service_Health_Nav_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre navigateur de santé`)
};

/**
* | output |
* | --- |
* | "Your Health Navigator" |
*
* @param {Service_Health_Nav_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_landing_title = /** @type {((inputs?: Service_Health_Nav_Landing_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_Landing_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_landing_title(inputs)
	return fr_service_health_nav_landing_title(inputs)
});